import {NgModule} from '@angular/core';
import {LogoOnlyHeaderComponent} from './logo-only-header.component';
import {CommonModule} from '@angular/common';

@NgModule({
    exports: [
        LogoOnlyHeaderComponent
    ],
    imports: [CommonModule],
    declarations: [LogoOnlyHeaderComponent]
})

export class LogoOnlyHeaderModule {
}
